import { withProfiler } from "@sentry/react";
import { StrictMode } from "react";

import { createBrowserRouter, RouterProvider } from "@shared/react-router-dom/react-router-dom";

import { getFullscriptRoutes, type Props } from "./routes";

const AuthLandingPage = (props: Props) => {
  const pageVersion = "prac_by_default_with_sso";

  return (
    <StrictMode>
      <RouterProvider
        router={createBrowserRouter(getFullscriptRoutes({ ...props, pageVersion }))}
      />
    </StrictMode>
  );
};

const AuthLandingPageWithProfiler = withProfiler(AuthLandingPage);
export { AuthLandingPageWithProfiler as AuthLandingPage };
